import { Type } from "nanium/objects";

// GeoJSON point as required by MongoDB 2dsphere indexes.
// NOTE: coordinates are [longitude, latitude] — GeoJSON order, NOT lat/lon!
export class GeoJsonPointType {
  @Type(String) type: 'Point';
  @Type(Array, Number) coordinates: number[];
}
